import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { isInternalLink, isSpecialProtocol } from '../utils/navigation';

/**
 * Custom hook for optimized navigation
 * Handles both internal (React Router) and external (window.location) navigation
 */
export const useNavigation = () => {
  const navigate = useNavigate();

  const handleNavigation = useCallback((href: string) => {
    // Special protocols (mailto:, tel:) always use window.location
    if (isSpecialProtocol(href)) {
      window.location.href = href;
      return;
    }

    // Internal links use React Router for SPA navigation
    if (isInternalLink(href)) {
      navigate(href);
      return;
    }

    // External links use window.location
    window.location.href = href;
  }, [navigate]);

  return handleNavigation;
};

